import React, { useEffect, useState, useRef } from 'react'
import {
  Radio,
  Layout,
  message,
  Col,
  Row,
  ConfigProvider,
  Pagination,
  Button,
  Input,
  Modal,
  Steps,
  Empty,
} from 'antd'
import {
  SearchOutlined,
  BulbOutlined,
  ScheduleOutlined,
  TeamOutlined,
  ClockCircleOutlined,
  CheckCircleOutlined,
} from '@ant-design/icons'
import projectStyles from './project.module.less'
import zhCN from 'antd/lib/locale/zh_CN'
import * as constants from '../../constants/constants'
import PageFooter from '../common/page-footer/footer'
import { checkUserLogin } from '../common/user-center/user-info'


import classempty from '../../static/image/noclassroom.png'
import teacher from '../../static/image/teacher.png'
import student from '../../static/image/student.png'
import lead0 from '../../static/image/lead0.svg'
import lead1 from '../../static/image/lead1.svg'
import lead2 from '../../static/image/lead2.svg'

import lock from '../../static/image/lock.svg'


import Cookies from 'js-cookie'
import { sendHttpPostRequest } from '../../api/http-request'
// import Feedback from '../common/feedback-help/feedback'
import CoursePaymentModal from './components/CoursePaymentModal'

import Draggable from 'react-draggable'



const pjDegreeList = [
    {label:"全部", value:0},
    {label:"初级", value:1},
    {label:"中级", value:2},
    {label:"高级", value:3},
]

const pjDegreeStyles = [
    {
      color: '#4f46e5',
      background: 'linear-gradient(135deg, #e0e7ff, #eef2ff)'
    },
    {
      color: '#b45309',
      background: 'linear-gradient(135deg, #fef3c7, #fef9c3)'
    },
    {
      color: '#dc2626',
      background: 'linear-gradient(135deg, #fee2e2, #fecaca)'
    },

  ]

const { Step } = Steps
const { Search } = Input

export interface Props {}
export const ProjectList: React.FC<Props> = (props) => {
  const ENV = process.env
  const [projectListResult, setProjectListResult] = useState(null as any)
  const [projectSum,setProjectSum ] = useState(0) // 查询到的项目总数

  
  const queryContent = useRef('')
  const page = useRef(1)
  const  difficulty = useRef(0) //难度选择
  const  category = useRef(0)  // 分类选择

  const [allCategory, setAllCategory] = useState([] as any) // 所有的分类
 
  const projectID = useRef(null as any) //当前选中的项目ID
  const selectedClassRoomId = useRef(null as any) //当前选中的教室ID
  const [selectedClassRoom, setSelectedClassRoom] = useState(null as any) //当前选中的教室
  const inputClassRoomPassword = useRef(null as any) //当前用户输入的教室密码

  const [joinVisible, setJoinVisible] = useState(false) //提示加入院校弹出框
  const [notPurchasedVisible, setNotPurchasedVisible] = useState(false) //未购买提示框
  const [delayVisible, setDelayVisible] = useState(false) //延期提示框
  const [accessPromptMessage, setAccessPromptMessage] = useState('') //弹窗提示内容
  const [notOnlineVisible, setNotOnlineVisible] = useState(false) //未上线提示框
  const [coursePaymentVisible, setCoursePaymentVisible] = useState(false)
  const [inClassVisible, setInClassVisible] = useState(false) //教室选择弹出框
  const [
    inputClassPasswordModalVisible,
    setInputClassPasswordModalVisible,
  ] = useState(false) //输入教室密码弹出框
  const [joinClassError, setJoinClassError] = useState('')  // 加入班级内联错误提示

  const [collegeId, setCollegeId] = useState(null as any) // 院校ID
  const [collegeName, setCollegeName] = useState(null as any) // 院校名称
  const [collegeInfo, setCollegeInfo] = useState(null as any) //查询当前用户的机构信息,is_college_teacher weitrue表示是教师，

  const [userInfo, setUserInfo] = useState(null as any) //当前用户的信息
  const [realName, setRealName] = useState(null as any) //保存当前学生真实姓名
  const [realNumber, setRealNumber] = useState(null as any) //学号

  const [label, setLabel] = useState('未购买')
  const pageClassRoom = useRef(1) // 记录当前的页数
  const pageSizeClassRoom = useRef(6) // 记录当前每页展示数量
  const [resultSumClassRoom, setResultSumClassRoom] = useState(null as any)
  const [projectClassRoomList, setProjectClassRoomList] = useState(null as any) //保存教室查询列表
  const queryClassRoom = useRef('') //教室查询
  const [current, setCurrent] = React.useState(0)



  const [myCollegeList, setMyCollegeList] = useState([] as any[]) //我的机构列表

  const [currentCollege, setCurrentCollege] = useState(null as any) //当前的机构

  const draggleRef = useRef<HTMLDivElement | null>(null)

  const [bounds, setBounds] = useState({ left: 0, top: 0, bottom: 0, right: 0 })
  const [disabled, setDisabled] = useState(true)


  const [isLocalDeploy, setIsLocalDeply] = useState(false) 
  const [searchValue, setSearchValue] = useState('')

  const getFilterChipClassName = (active: boolean) => {
    return active
      ? `${projectStyles.pjClassSpan} ${projectStyles.pjClassSpanActive}`
      : projectStyles.pjClassSpan
  }
  

  const onStart = (event: any, uiData: any) => {
    const { clientWidth, clientHeight } = window?.document?.documentElement
    const targetRect = draggleRef?.current?.getBoundingClientRect()
    if (targetRect) {
      setBounds({
        left: -targetRect?.left + uiData?.x,
        right: clientWidth - (targetRect?.right - uiData?.x),
        top: -targetRect?.top + uiData?.y,
        bottom: clientHeight - (targetRect?.bottom - uiData?.y),
      })
    }
  }


        /**
         * 查询后端，返回是否是本地部署
         */
        const checkIsLocalDeploy = () => {
  
          let data = {
  
          }
          try {
            sendHttpPostRequest(
              'get_is_deploy',
              data,
              (response)=> {
                message.destroy()
                if (response.is_ok) {
                  if(response?.deploy_type == 2){
                    setIsLocalDeply(true)
                  }
                } else {
                  //message.error('密码重置失败，请稍候再试')
                }
              }
            )
          } catch (e) {
            console.error(e)
          }
        }
  

  useEffect(() => {
    checkIsLocalDeploy()
    queryProjectList()
    queryCollegeInfo()
    queryAllCategoryList()
    sendHttpPostRequest(
      //获取院校身份信息
      'account/api/query_teacher_authenticate',
      {
        sessionid: Cookies.get('sessionid'),
        sid: Cookies.get('sessionid'),
      },
      (response: any) => {
        if (response.is_ok == true) {
          if (response?.college_id > 0) {
            //已加入机构
            let _collegeId = response.college_info.college_id
            setCollegeId(_collegeId)
            setCollegeInfo(response.college_info)
            setCollegeName(response.college_info.college_name)
            setMyCollegeList(response.college_list)
          }
        }
      }
    )

    queryUserInfo()
  }, [])

  // 查询用户信息回调
  const queryUserInfoCallback = (response: any) => {
    message.destroy()
    if (response.code == -100) {
      // 未登录
     // document.getElementById('show-login-modal')!.click()
      //没登录的用户不显示申请邀请码
      
    } else if (response.code == 0) {
      setUserInfo(response.data)
      setRealName(response.data.real_name)
      setRealNumber(response.data.number)
    } else {
      message.error(response.message)
    }
  }

  // 查询用户信息
  const queryUserInfo = () => {
    sendHttpPostRequest(
      'account/api/get_user_info/',
      {
        sessionid: Cookies.get('sessionid'),
        sid: Cookies.get('sessionid'),
      },
      queryUserInfoCallback
    )
  }

  // 保存用户信息回调
  const saveUserInfoCallback = (response: any) => {
    message.destroy()
    if (response.code == -100) {
      // 未登录
      document.getElementById('show-login-modal')!.click()
    } else if (response.code == 0) {
      message.success('更新用户信息成功')
      // 重设localStorage
      //queryUserInfo();
      sendHttpPostRequest(
        'classroom/api/user_add_classroom',
        {
          sessionid: Cookies.get('sessionid'),
          classroom_id: selectedClassRoomId.current,
          password: inputClassRoomPassword.current,
        },
        (response: any) => {
          message.destroy()
          if (response.code == -100) {
            // 未登录
            document.getElementById('show-login-modal')!.click()
          } else if (response.is_ok == true) {
            message.success('加入教室成功~')
            window.location.href =
              '/project_main_student?project_id=' + projectID.current
          } /*else if (response.code == -501) {
                            权限不足
                            window.location.href = '/oam_login?next=oam_menu';
                        } */ else {
            setJoinClassError(response.message || '加入班级失败，请重试')
          }
        }
      )
    } else {
      setJoinClassError(response.message || '保存用户信息失败，请重试')
    }
  }

  // 保存用户信息
  const saveUserInfo = () => {
    sendHttpPostRequest(
      'account/api/update_user_info/',
      {
        sessionid: Cookies.get('sessionid'),
        sid: Cookies.get('sessionid'),
        user_id: userInfo?.user_id,
        real_name: realName,
        number: realNumber,
        nick_name: userInfo?.nick_name,
      },
      saveUserInfoCallback
    )
  }

  // 点击实验卡片
  const onProjectCardClick = (
    isInCollege: boolean,
    isCollegeTeacher: boolean,
    projectId: number,
    publicStatus: number
  ) => {
    message.destroy()
    console.log(isInCollege)
    console.log(isCollegeTeacher)
    projectID.current = projectId

    if (!checkUserLogin()) {
      // 未登录先登录
      document.getElementById('show-login-modal')!.click()
    } else {
      const project = projectListResult?.filter(
        (item) => item.id == projectId
      )[0]

      const payReason = project?.access_info?.pay_reason

      if (project?.ispay == 1 && project?.isoutdate != 1) {
        // 机构授权有效的教师：进教师页
        if (payReason === 'teacher_bypass' && isCollegeTeacher) {
          window.open('/project_main?project_id=' + projectId)
        } else {
          // 个人付费（包括教师个人付费）或机构学生：进学生页
          window.open('/project_main_student?project_id=' + projectId)
        }
        return
      }

      if (isInCollege == false) {
        //没有加机构
        setJoinVisible(true)
        return
      }

      //检查项目是否购买或者是否已经过期
      const payReasonFallback = project?.access_info?.pay_reason
      if (project?.public_status == 2) {
        setNotOnlineVisible(true)
      } else if (payReasonFallback === 'college_or_course_expired' || project?.isoutdate == 1) {
        //已过期，需续约
        setAccessPromptMessage('机构授权已过期，可联系销售续约机构，或个人付费继续使用。')
        setDelayVisible(true)
      } else if (payReasonFallback === 'college_course_unconfigured') {
        //机构未配置该课程
        setAccessPromptMessage('机构尚未购买该项目，合作咨询')
        setNotPurchasedVisible(true)
      } else if (project?.ispay == 0) {
        //未购买（无机构或其他原因）
        setAccessPromptMessage('你可以联系机构管理员/工作人员开通，或个人付费继续使用。')
        setNotPurchasedVisible(true)
      } else {
        if (isInCollege == true && isCollegeTeacher == true) {
          window.open('/project_main?project_id=' + projectId)
        } else if (
          isInCollege == true &&
          isCollegeTeacher == false &&
          project.in_classroom == 1
        ) {
          window.open('/project_main_student?project_id=' + projectId)
          window.name = 'project_main_student'
        } else if (
          isInCollege == true &&
          isCollegeTeacher == false &&
          project.in_classroom == 0
        ) {
          //机构学生尚未加本项目教室
          //先查询本项目下的教室列表
          queryProjectClassRoomList(projectId, collegeId, true)
        }
      }
    }
  }


  //页码和页数发生了变化
  const onPageChange = (newPage: number, newPageSize?: number | undefined) => {
    page.current = newPage ? newPage : 1

    queryProjectList()
  }

    //点击了搜索按钮
    const onSearchBtn = (value?: string) => {
      const nextQuery = typeof value === 'string' ? value : searchValue
      queryContent.current = nextQuery.trim()
      setSearchValue(nextQuery)
        page.current = 1
        queryProjectList()
    }


      /**
   * 查询项目分类列表
   */
  const queryAllCategoryList = () => {
    sendHttpPostRequest(
      'course/api/query_project_category',

      {
        sessionid: Cookies.get('sessionid'),
        sid: Cookies.get('sessionid'),

      },
      (response: any) => {
        message.destroy()
        if (response.code == -100) {
          // 未登录
          //window.location.href = '/login?next=project'
        } else if (response.is_ok == true) {
          // 成功
          setAllCategory(response?.data)
        }
      }
    )
    
  }

  /**
   * 查询项目列表
   */
  const queryProjectList = () => {
    sendHttpPostRequest(
      'course/api/query_project_list',

      {
        sessionid: Cookies.get('sessionid'),
        sid: Cookies.get('sessionid'),
        query: queryContent.current,
        page: page.current,
        pagesize:9,
        difficulty:difficulty.current, //初级中级高级
        category: category.current,  // 分类筛选

      },
      queryProjectListCallback
    )
  }

    const onQueryContentChange = (event: any) => {
      const nextValue = event.target.value
      setSearchValue(nextValue)
      queryContent.current = nextValue

      if (nextValue === '') {
        page.current = 1
        queryProjectList()
      }
  }

  /**
   * 查询项目列表回调
   * @param response
   */
  const queryProjectListCallback = (response: any) => {
    message.destroy()
    if (response.code == -100) {
      // 未登录
      window.location.href = '/login?next=project'
    } else if (response.is_ok == true) {
      // 成功
      setProjectListResult(response?.query_list)
      setProjectSum(response?.total_count)
    }
  }
  /** 查询当前学生所在机构的某个项目的所有教师列表 */
  const queryProjectClassRoomList = (projectId, collegeID, showModal) => {
    sendHttpPostRequest(
      'classroom/api/user_query_classroom_list/',
      {
        sessionid: Cookies.get('sessionid'),
        course_id: projectId,
        college_id: collegeID,
        query: queryClassRoom.current,
        page: pageClassRoom.current,
        pagesize: pageSizeClassRoom.current,
      },
      (response: any) => {
        // console.log(response)
        message.destroy()
        if (response.code == -100) {
          // 未登录
          document.getElementById('show-login-modal')!.click()
        } else if (response.is_ok == true) {
          setProjectClassRoomList(response.query_list)
          setResultSumClassRoom(response.total_sum)

          if (showModal == true) {
            setInClassVisible(true)
          }
        } /*else if (response.code == -501) {
                    权限不足
                    window.location.href = '/oam_login?next=oam_menu';
                } */ else {
          message.error(response.message)
        }
      }
    )
  }

  const queryCollegeInfo = () => {
    sendHttpPostRequest(
      'account/api/query_teacher_authenticate',
      {
        sessionid: Cookies.get('sessionid'),
        sid: Cookies.get('sessionid'),
      },
      (response: any) => {
        if (response?.is_ok == true) {
          setMyCollegeList(response.college_list)
          setCurrentCollege(response.college_info)
        }
      }
    )
  }

  //教室页码和页数发生了变化
  const onClassRoomPageChange = (
    newPage: number,
    newPageSize?: number | undefined
  ) => {
    pageClassRoom.current = newPage ? newPage : 1
    if (newPageSize) {
      pageSizeClassRoom.current = newPageSize
    }
    queryProjectClassRoomList(projectID.current, collegeId, false)
  }

  /** 学生加入某个班级 */
  const onConfirmInputClass = () => {
    setJoinClassError('')
    if (realName?.trim() == '') {
      setJoinClassError('真实姓名不能为空~')
      return ''
    }

    if (realNumber?.trim() == '') {
      setJoinClassError('学号不能为空~')
      return ''
    }

    saveUserInfo()
  }

  const getColorByLabel = (label: string) => {
    if (label == '未购买') return 'rgba(79, 70, 229, 1)'
    if (label == '已到期') return 'rgba(239, 68, 68, 1)'
    else return 'rgba(255, 255, 255,1)'
  }

  const getFontColorByLabel = (label: string) => {
    if (label == '未购买') return '#fff'
    if (label == '已到期') return '#fff'
    else return '#4f46e5'
  }

  const getProjectStatusLabel = (project: any): string => {
    const payReason = project?.access_info?.pay_reason
    if (payReason === 'college_or_course_expired' || project?.isoutdate == 1) return '已到期'
    if (project?.ispay == 0) return '未购买'
    return ''
  }

  const steps = [
    
    {
      title: '获取院校码',
      content: (
        <div style={{ textAlign: 'center' }}>
          <div
            style={{
              textAlign: 'left',
              color: '#000',
              margin: '10px 0',
              paddingLeft: 10,
            }}
          >
            院校码示意图：
          </div>
          <Row style={{ color: '#333' }}>
            <Col span={12} style={{ textAlign: 'center' }}>
              <div className={projectStyles.collegeNum}>
                <img
                  src={teacher}
                  width={60}
                  height={60}
                  style={{ marginTop: -20 }}
                />
                <div
                  style={{
                    textAlign: 'left',
                    marginTop: 10,
                    display: 'inline-block',
                  }}
                >
                  教师码
                  <br />
                  XLJBLERK
                </div>
              </div>
            </Col>
            <Col span={12} style={{ textAlign: 'center' }}>
              <div className={projectStyles.collegeNum}>
                <img
                  src={student}
                  width={60}
                  height={60}
                  style={{ marginTop: -20 }}
                />
                <div
                  style={{
                    textAlign: 'left',
                    marginTop: 10,
                    display: 'inline-block',
                  }}
                >
                  学生码
                  <br />
                  XDCFVJGF
                </div>
              </div>
            </Col>
          </Row>
          <div
            style={{
              textAlign: 'left',
              color: '#000',
              margin: '10px 0',
              marginLeft: 10,
            }}
          >
            如无院校码，请点击菜单上方的获取院校码按钮
          </div>
          <img src={lead0} width={450} height={130} alt="" />
        </div>
      ),
    },
    {
      title: '填写院校码',
      content: (
        <div style={{ textAlign: 'center', marginTop: 10 }}>
          <div
            style={{
              textAlign: 'left',
              color: '#000',
              margin: '6px 0',
              marginLeft: 10,
            }}
          >
            在个人中心填写院校码，点击提交
          </div>
          <img src={lead1} width={400} height={250} alt="" />
        </div>
      ),
    },
    {
      title: '完成认证',
      content: (
        <div style={{ textAlign: 'center', marginTop: 10 }}>
          <div
            style={{
              textAlign: 'left',
              color: '#000',
              margin: '6px 0',
              marginLeft: 10,
            }}
          >
            个人中心显示院校即为认证成功
          </div>
          <img src={lead2} width={400} height={250} alt="" />
        </div>
      ),
    },
  ]

  return (
    <Layout style={{ minHeight: 750, backgroundColor: '#f9f9f9' }}>
      <div className={projectStyles.maincontent}>
        <div className={projectStyles.projectList}>

          <div className={projectStyles.filterPanel}>
            <div className={projectStyles.filterToolbar}>
              <div className={projectStyles.searchBox}>
                <div className={projectStyles.searchLabelRow}>
                  <div className={projectStyles.filterLabel}>搜索项目</div>
                  <div className={projectStyles.searchMeta}>共 {projectSum} 个项目</div>
                </div>

                <Search
                  value={searchValue}
                  onSearch={onSearchBtn}
                  onChange={onQueryContentChange}
                  size="large"
                  placeholder="搜索实训项目、技能方向或行业主题..."
                  prefix={<SearchOutlined />}
                  allowClear
                  enterButton="搜索"
                  className={projectStyles.searchInput}
                />
              </div>

            </div>

            <div className={projectStyles.filterSection}>
              <div className={projectStyles.filterLabel}>项目分类</div>
              <div className={projectStyles.pjClassWrapper}>
                <span
                  className={getFilterChipClassName(category.current == 0)}
                  onClick={() => {
                    category.current = 0
                    page.current = 1
                    queryProjectList()
                  }}
                >
                  全部
                </span>

                {allCategory?.map((pjClass, index) => (
                  <span
                    key={index}
                    onClick={() => {
                      category.current = pjClass?.id
                      page.current = 1
                      queryProjectList()
                    }}
                    className={getFilterChipClassName(category.current == pjClass?.id)}
                  >
                    {pjClass?.name}
                  </span>
                ))}
              </div>
            </div>

            <div className={projectStyles.filterSection}>
              <div className={projectStyles.filterLabel}>难度级别</div>
              <div className={projectStyles.pjClassWrapper}>
                {pjDegreeList?.map((pjDegree, index) => (
                  <span
                    onClick={() => {
                      difficulty.current = pjDegree?.value
                      page.current = 1
                      queryProjectList()
                    }}
                    className={getFilterChipClassName(difficulty.current == pjDegree?.value)}
                    key={index}
                  >
                    {pjDegree?.label}
                  </span>
                ))}
              </div>
            </div>
          </div>

          {projectListResult?.length > 0 ? (
            <Row gutter={[24, 24]} className={projectStyles.projectGrid}>
              {projectListResult?.map((project) => (
                <Col xs={24} sm={12} xl={8} key={project?.id}>
                  <div className={projectStyles.projectCard}>
                    <div className={projectStyles.projectCover} style={{ cursor: 'pointer' }} onClick={() => { window.open('/project_detail?project_id=' + project?.id) }}>
                      <img src={constants.BACKEND_API_URL + project.cover} alt={project?.name} />
                      <div className={projectStyles.coverGradientOverlay} />
                      <span className={projectStyles.projectTag}>{project?.industry_name}</span>

                      <span className={projectStyles.durationTag}>
                        <ClockCircleOutlined style={{ marginRight: 6 }} /> {project?.practice_duration} 课时
                      </span>

                      {project?.public_status !== 2 && collegeInfo?.college_id > 0 && getProjectStatusLabel(project) !== '' && (
                        <div
                          className={projectStyles.projectLabel}
                          style={{
                            backgroundColor: getColorByLabel(getProjectStatusLabel(project)),
                            color: getFontColorByLabel(getProjectStatusLabel(project)),
                          }}
                        >
                          {getProjectStatusLabel(project)}
                        </div>
                      )}
                    </div>

                    <div className={projectStyles.projectCardBody}>
                      <div className={projectStyles.projectHeaderRow}>
                        <div className={projectStyles.projectName} onClick={() => { window.open('/project_detail?project_id=' + project?.id) }}>{project?.name}</div>

                        <span
                          style={project?.difficulty == 0 ? pjDegreeStyles[0] : pjDegreeStyles[project?.difficulty - 1]}
                          className={projectStyles.projectDegreeTag}
                        >
                          {project?.difficulty == 1 || project?.difficulty == 0 ? '初级' : project?.difficulty == 2 ? '中级' : '高级'}
                        </span>
                      </div>

                      <div className={projectStyles.projectDesp}>{project?.description}</div>

                      {project?.ability?.split(';')?.filter(Boolean)?.length > 0 && (
                        <div className={projectStyles.projectSkillWrapper}>
                          {project?.ability
                            ?.split(';')
                            ?.filter(Boolean)
                            ?.map((skill, index) => (
                              <span className={projectStyles.projectSkill} key={index}>
                                {skill}
                              </span>
                            ))}
                        </div>
                      )}

                      {project?.tools?.split(';')?.filter(Boolean)?.length > 0 && (
                        <div className={projectStyles.projectToolsWrapper}>
                          <ScheduleOutlined style={{ fontSize: 12, marginRight: 4, flexShrink: 0 }} />
                          {project?.tools
                            ?.split(';')
                            ?.filter(Boolean)
                            ?.map((tool, index, arr) => (
                              <span key={index}>
                                <span className={projectStyles.projectTool}>{tool}</span>
                                {index < arr.length - 1 && <span className={projectStyles.projectToolDot}>·</span>}
                              </span>
                            ))}
                        </div>
                      )}

                      <div className={projectStyles.projectFooterRow}>
                        <div className={projectStyles.projectLearningCount}>
                          <TeamOutlined style={{ marginRight: 6 }} /> {project?.active_user_count} 人
                        </div>

                        <div className={projectStyles.projectActionGroup}>
                          <Button
                            onClick={() => {
                              window.open('/project_detail?project_id=' + project?.id)
                            }}
                            className={projectStyles.projectDetailBtn}
                          >
                            项目详情
                          </Button>

                          <Button
                            onClick={() => {
                              onProjectCardClick(
                                collegeId !== 0 && collegeId !== null && collegeId !== '',
                                collegeInfo?.is_college_teacher == 1,
                                project.id,
                                project.public_status
                              )
                            }}
                            className={projectStyles.projectEnterBtn}
                          >
                            {project.public_status == 2 ? (
                              <img src={lock} className={projectStyles.lockIcon} />
                            ) : (
                              ''
                            )}
                            进入项目
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          ) : (
            <div className={projectStyles.emptyStateWrapper}>
              <Empty description="未找到匹配的实训项目，换个关键词或筛选条件试试" />
            </div>
          )}

          {/**<Row gutter={24}>
            {projectListResult?.map((project, index) => {
              return (
                  <Col key={project.id} 
                  span={12}>
                  <div 
                  
                    className={projectStyles.projectCard}
                    id={`project-cart-btnshow${index}`}
                  >
                    <img
                      src={constants.BACKEND_API_URL + project.cover}
                      alt=""
                      className={projectStyles.projectImg}
                    />

                    {project?.public_status !== 2 && collegeInfo?.college_id > 0 && (
                      <div
                        className={projectStyles.projectLabel}
                        style={{
                          backgroundColor: getColorByLabel(
                            project?.ispay == 0
                              ? '未购买'
                              : project?.isoutdate == 1
                              ? '需延期'
                              : ''
                          ),
                          color: getFontColorByLabel(
                            project?.ispay == 0
                              ? '未购买'
                              : project?.isoutdate == 1
                              ? '需延期'
                              : ''
                          ),
                        }}
                      >
                        {project?.ispay == 0
                          ? '未购买'
                          : project?.isoutdate == 1
                          ? '需延期'
                          : ''}
                      </div>
                    )}
                    <div className={projectStyles.projectContent}>
                      <div className={projectStyles.projectTitle}>
                        {project.name}
                      </div>
                      <div
                        className={projectStyles.projectDescription}
                        title={project.description}
                      >
                        {project.description}
                      </div>
                      <Row
                        wrap={false}
                        align="middle"
                        justify="start"
                        gutter={[12, 12]}
                        style={{ width: '100%', overflow: 'hidden' }}
                      >
                        {project.ability?.split(';')?.map((skill, skillInd) => {
                          return (
                            <Col key={skillInd} className={projectStyles.list}>
                              {skill}
                            </Col>
                          )
                        })}
                      </Row>
                      <Row
                        wrap={false}
                        align="middle"
                        justify="start"
                        gutter={[12, 12]}
                        style={{ marginTop: 40, position: 'relative' }}
                        className={projectStyles.infoDiv}
                      >
                        <Col
                          style={{
                            width: 100,
                            height: 50,
                            color: '#fff!important',
                            marginRight: 20,
                            borderRight: '1px solid rgba(255, 255, 255, 0.2)',
                          }}
                        >
                          <div>行业</div>
                          <div style={{ fontSize: 18, textOverflow: 'ellipsis' }}>
                            {project.industry_name}
                          </div>
                        </Col>

                        <Col
                          style={{
                            width: 100,
                            height: 50,
                            color: '#fff!important',
                            marginRight: 20,
                            borderRight: '1px solid rgba(255, 255, 255, 0.2)',
                          }}
                        >
                          <div>实践课时</div>
                          <div style={{ fontSize: 18 }}>
                            {project.practice_duration}
                          </div>
                        </Col>

                        <Col
                          style={{
                            width: 100,
                            height: 50,
                            color: '#fff!important',
                            marginRight: 20,
                            borderRight: '1px solid rgba(255, 255, 255, 0.2)',
                          }}
                        >
                          <div>教学课时</div>
                          <div style={{ fontSize: 18 }}>
                            {project.teaching_duration}
                          </div>
                        </Col>
                      </Row>
                    </div>

                    <div
                      className={projectStyles.startBtn}
                      style={{
                        transform: 'translate(-50%,0)',
                        position: 'absolute',
                        left: '50%',
                        bottom: 40,
                        display: 'none',
                        zIndex: 10,
                      }}
                    >
                      <Button
                        onClick={() => {
                          window.open('/project_detail?project_id=' + project?.id)
                        }}
                        style={{
                          borderRadius: 27,
                          backgroundColor: '#fff',
                          width: 120,
                          height: 40,
                          color: '#4f46e5',
                          marginRight:20
                        }}
                      >
                        项目详情
                      </Button>

                      <Button
                        id={`go-into-project${index}`}
                        onClick={() => {
                          onProjectCardClick(
                            collegeId !== 0 &&
                              collegeId !== null &&
                              collegeId !== '',
                            collegeInfo?.is_college_teacher == 1,
                            project.id,
                            project.public_status
                          )
                        }}
                        style={{
                          borderRadius: 27,
                          backgroundColor: '#4f46e5',
                          borderColor:'#4f46e5',
                          width: 120,
                          height: 40,
                          color: '#fff',
                          
                        }}
                      >
                        {project.public_status == 2 ? (
                          <img
                            src={lock}
                            style={{
                              width: 18,
                              height: 14,
                              marginRight: 5,
                              marginTop: -2,
                            }}
                          />
                        ) : (
                          ''
                        )}
                        进入项目
                      </Button>
                    </div>
                  </div>

                  </Col>
                
              )
            }


            )
            
            }
          </Row>*/}



          <ConfigProvider locale={zhCN}>
            <div className={projectStyles.pagination} style={{marginTop:24}}>
              <Pagination
                defaultCurrent={1}
                total={projectSum}
                current={page.current}
                defaultPageSize={9}
                hideOnSinglePage={true}
                onChange={onPageChange}
              />
            </div>
          </ConfigProvider>


          <Modal
            title={
              <div
                style={{ width: '100%', cursor: 'move', color: '#333' }}
                onMouseOver={() => {
                  if (disabled) {
                    setDisabled(false)
                  }
                }}
                onMouseOut={() => {
                  setDisabled(true)
                }}
                onFocus={() => {}}
                onBlur={() => {}}
              >
                提示
              </div>
            }
            width={350}
            className={projectStyles.whiteModal}
            closable={false}
            centered={true}
            visible={notPurchasedVisible}
            bodyStyle={{ height: 80 }}
            footer={
              <div>
                <Button
                  className={projectStyles.stepsBtn}
                  style={{
                    marginRight: 20,
                    backgroundColor: '#f2f2f2',
                    border: 0,
                  }}
                  onClick={() => {
                    setNotPurchasedVisible(false)
                  }}
                >
                  取消
                </Button>
                <Button
                  className={projectStyles.stepsBtn}
                  style={{ marginRight: 20, color: '#fff' }}
                  type="primary"
                  onClick={() => {
                    setNotPurchasedVisible(false)
                    setCoursePaymentVisible(true)
                  }}
                >
                  个人付费
                </Button>
              </div>
            }
            modalRender={(modal) => (
              <div>
                <Draggable
                  disabled={disabled}
                  bounds={bounds}
                  onStart={(event, uiData) => onStart(event, uiData)}
                >
                  <div ref={draggleRef}>{modal}</div>
                </Draggable>{' '}
              </div>
            )}
          >
            <div style={{ width: 300, textAlign: 'center', color: '#333' }}>
              {accessPromptMessage || '院校未购买该项目，合作咨询'}
              <div style={{ color: '#4f46e5', marginTop: 6 }}>
                136 9329 0406
              </div>
            </div>
          </Modal>

          <Modal
            title={
              <div
                style={{ width: '100%', cursor: 'move', color: '#333' }}
                onMouseOver={() => {
                  if (disabled) {
                    setDisabled(false)
                  }
                }}
                onMouseOut={() => {
                  setDisabled(true)
                }}
                onFocus={() => {}}
                onBlur={() => {}}
              >
                提示
              </div>
            }
            width={350}
            className={projectStyles.whiteModal}
            closable={false}
            centered={true}
            open={delayVisible}
            bodyStyle={{ height: 80 }}
            footer={
              <div>
                <Button
                  className={projectStyles.stepsBtn}
                  style={{
                    marginRight: 20,
                    backgroundColor: '#f2f2f2',
                    border: 0,
                  }}
                  onClick={() => {
                    setDelayVisible(false)
                  }}
                >
                  取消
                </Button>
                <Button
                  className={projectStyles.stepsBtn}
                  style={{ marginRight: 20, color: '#fff' }}
                  type="primary"
                  onClick={() => {
                    setDelayVisible(false)
                    setCoursePaymentVisible(true)
                  }}
                >
                  个人付费
                </Button>
              </div>
            }
            modalRender={(modal) => (
              <div>
                <Draggable
                  disabled={disabled}
                  bounds={bounds}
                  onStart={(event, uiData) => onStart(event, uiData)}
                >
                  <div ref={draggleRef}>{modal}</div>
                </Draggable>{' '}
              </div>
            )}
          >
            <div style={{ width: 300, textAlign: 'center', color: '#333' }}>
              {accessPromptMessage || '机构授权已过期，可联系销售续约机构，或个人付费继续使用。'}
              <div style={{ color: '#4f46e5', marginTop: 6 }}>
                136 9329 0406
              </div>
            </div>
          </Modal>

          <CoursePaymentModal
            visible={coursePaymentVisible}
            courseId={projectID.current || 0}
            onSuccess={() => {
              setCoursePaymentVisible(false)
              queryProjectList()
              if (projectID.current) {
                window.open('/project_detail?project_id=' + projectID.current)
              }
            }}
            onCancel={() => {
              setCoursePaymentVisible(false)
            }}
          />

          <Modal
            title={
              <div
                style={{ width: '100%', cursor: 'move', color: '#333' }}
                onMouseOver={() => {
                  if (disabled) {
                    setDisabled(false)
                  }
                }}
                onMouseOut={() => {
                  setDisabled(true)
                }}
                onFocus={() => {}}
                onBlur={() => {}}
              >
                提示
              </div>
            }
            width={350}
            className={projectStyles.whiteModal}
            closable={false}
            centered={true}
            visible={notOnlineVisible}
            bodyStyle={{ height: 80 }}
            footer={
              <div>
                <Button
                  className={projectStyles.stepsBtn}
                  style={{
                    marginRight: 20,
                    backgroundColor: '#f2f2f2',
                    border: 0,
                  }}
                  onClick={() => {
                    setNotOnlineVisible(false)
                  }}
                >
                  取消
                </Button>
                <Button
                  className={projectStyles.stepsBtn}
                  style={{ marginRight: 20, color: '#fff' }}
                  type="primary"
                  onClick={() => {
                    setNotOnlineVisible(false)
                  }}
                >
                  确认
                </Button>
              </div>
            }
            modalRender={(modal) => (
              <div>
                <Draggable
                  disabled={disabled}
                  bounds={bounds}
                  onStart={(event, uiData) => onStart(event, uiData)}
                >
                  <div ref={draggleRef}>{modal}</div>
                </Draggable>{' '}
              </div>
            )}
          >
            <div
              style={{
                width: 300,
                textAlign: 'center',
                color: '#333',
                marginTop: 10,
              }}
            >
              打造中，敬请期待~
            </div>
          </Modal>

          <Modal
            title={
              <div
                style={{ width: '100%', cursor: 'move', color: '#333' }}
                onMouseOver={() => {
                  if (disabled) {
                    setDisabled(false)
                  }
                }}
                onMouseOut={() => {
                  setDisabled(true)
                }}
                onFocus={() => {}}
                onBlur={() => {}}
              >
                <BulbOutlined style={{ marginRight: 5 }} />
                尊敬的用户您好，您还未加入所在院校。
              </div>
            }
            width={600}
            className={projectStyles.whiteModal}
            closable={true}
            onCancel={() => {
              setJoinVisible(false)
            }}
            centered={true}
            open={joinVisible}
            bodyStyle={{ height: 380 }}
            footer={
              <div
                style={{ textAlign: 'center', height: '100%', paddingTop: 10 }}
              >
                {current > 0 && current < steps.length - 1 && (
                  <Button
                    className={projectStyles.stepsBtn}
                    style={{ color: '#4f46e5', marginRight: 50 }}
                    onClick={() => {
                      setCurrent(current - 1)
                    }}
                  >
                    上一步
                  </Button>
                )}
                {current < steps.length - 1 && (
                  <Button
                    className={projectStyles.stepsBtn}
                    style={{ color: '#4f46e5' }}
                    onClick={() => {
                      setCurrent(current + 1)
                    }}
                  >
                    下一步
                  </Button>
                )}
                {current == steps.length - 1 && (
                  <Button
                    className={projectStyles.stepsBtn}
                    style={{ color: '#4f46e5', padding: 0, marginRight: 50 }}
                    onClick={() => {
                      setCurrent(0)
                    }}
                  >
                    重新观看
                  </Button>
                )}
                {current == steps.length - 1 && (
                  <Button
                    className={projectStyles.stepsBtn}
                    style={{ color: '#fff', padding: 0 }}
                    type="primary"
                    onClick={() => {
                      setJoinVisible(false)
                    }}
                  >
                    我已了解
                  </Button>
                )}
                <Button
                  className={projectStyles.stepsBtn}
                  style={{ color: '#fff', padding: 0, marginLeft: 20 }}
                  type="primary"
                  onClick={() => {
                    setJoinVisible(false)
                    setCoursePaymentVisible(true)
                  }}
                >
                  个人付费
                </Button>
              </div>
            }
            modalRender={(modal) => (
              <div>
                <Draggable
                  disabled={disabled}
                  bounds={bounds}
                  onStart={(event, uiData) => onStart(event, uiData)}
                >
                  <div ref={draggleRef}>{modal}</div>
                </Draggable>{' '}
              </div>
            )}
          >
            <div style={{ marginBottom: 10, color: '#000', marginLeft: 10 }}>
              加入院校方法如下：
            </div>
            <Steps
              size="small"
              labelPlacement="vertical"
              current={current}
              style={{ marginTop: 0 }}
            >
              {steps.map((item) => (
                <Step key={item.title} title={item.title} />
              ))}
            </Steps>
            <div>{steps[current].content}</div>
          </Modal>
          {/*
          <Modal
            title={
              <div
                style={{ color: '#666', cursor: 'move' }}
                onMouseOver={() => {
                  if (disabled) {
                    setDisabled(false)
                  }
                }}
                onMouseOut={() => {
                  setDisabled(true)
                }}
                onFocus={() => {}}
                onBlur={() => {}}
              >
                请加入班级
                <Input
                  placeholder="ID/名称/老师"
                  suffix={<SearchOutlined style={{ color: '#666666' }} />}
                  onChange={(e) => {
                    queryClassRoom.current = e.target.value
                  }}
                  onPressEnter={(e) => {
                    queryProjectClassRoomList(
                      projectID.current,
                      collegeId,
                      false
                    )
                  }}
                />
              </div>
            }
            width={800}
            closable={false}
            centered={true}
            open={inClassVisible}
            bodyStyle={{ height: 450 }}
            className={projectStyles.chooseClassRoomDiv}
            footer={
              <div>
                <Pagination
                  style={{ float: 'left' }}
                  defaultCurrent={1}
                  total={resultSumClassRoom}
                  defaultPageSize={9}
                  current={pageClassRoom.current}
                  hideOnSinglePage={true}
                  onChange={onClassRoomPageChange}
                />

                <Button
                  className={projectStyles.stepsBtn}
                  style={{ marginRight: 20, color: '#fff', float: 'right' }}
                  type="primary"
                  onClick={() => {
                    setInputClassPasswordModalVisible(true)
                  }}
                >
                  确认
                </Button>
                <Button
                  className={projectStyles.stepsBtn}
                  style={{
                    marginRight: 20,
                    backgroundColor: '#f2f2f2',
                    border: 0,
                    float: 'right',
                  }}
                  onClick={() => {
                    setInClassVisible(false)
                  }}
                >
                  取消
                </Button>
              </div>
            }
            modalRender={(modal) => (
              <div>
                <Draggable
                  disabled={disabled}
                  bounds={bounds}
                  onStart={(event, uiData) => onStart(event, uiData)}
                >
                  <div ref={draggleRef}>{modal}</div>
                </Draggable>{' '}
              </div>
            )}
          >
            {projectClassRoomList?.length != 0 ? (
              <Radio.Group
                buttonStyle="solid"
                onChange={(e: any) => {
                  selectedClassRoomId.current = e.target.value.id
                  setSelectedClassRoom(e.target.value)
                }}
              >
                {projectClassRoomList?.map((class_) => {
                  return (
                    <Radio.Button key={class_.id} value={class_}>
                      <div className={projectStyles.classList}>
                        <div className={projectStyles.classId}>{class_.id}</div>
                        <div style={{ fontSize: 16 }}>{class_.name}</div>
                        <div
                          style={{
                            marginTop: 10,
                            paddingLeft: 40,
                            textAlign: 'left',
                            fontSize: 12,
                            opacity: 0.8,
                          }}
                        >
                          老师：
                          {class_?.teacher_real_name == ''
                            ? class_?.teacher_name
                            : class_?.teacher_real_name}
                        </div>
                        <div
                          style={{
                            paddingLeft: 40,
                            textAlign: 'left',
                            fontSize: 12,
                            opacity: 0.8,
                          }}
                        >
                          班号：{class_.number}
                        </div>
                      </div>
                    </Radio.Button>
                  )
                })}
              </Radio.Group>
            ) : (
              <div
                style={{ width: '100%', textAlign: 'center', color: '#ccc' }}
              >
                <img
                  src={classempty}
                  alt=""
                  width={200}
                  height={200}
                  style={{ margin: '40px auto' }}
                />
                <p>老师还未创建班级哦，请联系老师~</p>
              </div>
            )}
          </Modal>

          <Modal
            title={
              <div
                style={{ color: '#666', cursor: 'move' }}
                onMouseOver={() => {
                  if (disabled) {
                    setDisabled(false)
                  }
                }}
                onMouseOut={() => {
                  setDisabled(true)
                }}
                onFocus={() => {}}
                onBlur={() => {}}
              >
                加入班级:{selectedClassRoom?.name}
              </div>
            }
            width={260}
            closable={false}
            centered={true}
            open={inputClassPasswordModalVisible}
            bodyStyle={{
              padding: '0px 10px 0px 10px',
              textAlign: 'center',
              height: 100,
            }}
            className={projectStyles.chooseClassRoomDiv}
            footer={
              <div>
                <Button
                  className={projectStyles.stepsBtn}
                  style={{ marginRight: 20, color: '#fff', float: 'right' }}
                  type="primary"
                  onClick={onConfirmInputClass}
                >
                  确认
                </Button>
                <Button
                  className={projectStyles.stepsBtn}
                  style={{
                    marginRight: 20,
                    backgroundColor: '#f2f2f2',
                    border: 0,
                    float: 'right',
                  }}
                  onClick={() => {
                    setInputClassPasswordModalVisible(false)
                  }}
                >
                  取消
                </Button>
              </div>
            }
            modalRender={(modal) => (
              <div>
                <Draggable
                  disabled={disabled}
                  bounds={bounds}
                  onStart={(event, uiData) => onStart(event, uiData)}
                >
                  <div ref={draggleRef}>{modal}</div>
                </Draggable>{' '}
              </div>
            )}
          >
            <Row gutter={[4, 4]} justify="end" style={{ marginBottom: 10 }}>
              <Col flex="50px" style={{ textAlign: 'right', color: '#333' }}>
                密码
              </Col>
              <Col flex="auto" style={{ textAlign: 'left' }}>
                <Input
                  style={{ borderRadius: 3, width: 150 }}
                  onChange={(e) => {
                    inputClassRoomPassword.current = e.target.value
                  }}
                  placeholder="请输入班级密码"
                />{' '}
              </Col>
            </Row>

            <Row gutter={[4, 4]} justify="end" style={{ marginBottom: 10 }}>
              <Col flex="50px" style={{ textAlign: 'right', color: '#333' }}>
                姓名
              </Col>
              <Col flex="auto" style={{ textAlign: 'left' }}>
                <Input
                  style={{ borderRadius: 3, width: 150 }}
                  value={realName}
                  onChange={(e) => {
                    setRealName(e.target.value)
                  }}
                  placeholder="请输入真实姓名"
                />{' '}
              </Col>
            </Row>

            <Row gutter={[4, 4]} justify="end" style={{ marginBottom: 10 }}>
              <Col flex="50px" style={{ textAlign: 'right', color: '#333' }}>
                学号
              </Col>
              <Col flex="auto" style={{ textAlign: 'left' }}>
                <Input
                  value={realNumber}
                  style={{ borderRadius: 3, width: 150 }}
                  onChange={(e) => {
                    setRealNumber(e.target.value)
                  }}
                  placeholder="请输入学号"
                />{' '}
              </Col>
            </Row>
          </Modal>
 */}

          <Modal
            title={
              <div
                style={{ width: '100%', cursor: 'move' }}
                onMouseOver={() => {
                  if (disabled) {
                    setDisabled(false)
                  }
                }}
                onMouseOut={() => {
                  setDisabled(true)
                }}
                onFocus={() => {}}
                onBlur={() => {}}
              >
                请选择班级
              </div>
            }
            width={916}
            closable={true}
            onCancel={()=>{setInClassVisible(false)}}
            centered={true}
            open={inClassVisible}
            bodyStyle={{ height: 610 }}
            className={projectStyles.changeClassModal}
            footer={
              <div>

                <Button
                  className={projectStyles.stepsBtn}
                  style={{ marginRight: 20 ,color:'#fff', background:'#4f46e5', borderColor:'#4f46e5'}}
                  type="primary"
                  onClick={() => {
                    setInputClassPasswordModalVisible(true)
                  }}
                >
                  确认选择
                </Button>
                <Button
                  className={projectStyles.stepsBtn}
                  style={{
                    marginRight: 20,
                    backgroundColor: 'rgba(250,250,250,.1)',
                    color: 'rgb(55 65 81)',
                    border: '1px solid rgb(209 213 219)',
                    //float: 'right',
                  }}
                  onClick={() => {
                    setInClassVisible(false)
                  }}
                >
                  取消
                </Button>
              </div>
            }
            modalRender={(modal) => (
              <div>
                <Draggable
                  disabled={disabled}
                  bounds={bounds}
                  onStart={(event, uiData) => onStart(event, uiData)}
                >
                  <div ref={draggleRef}>{modal}</div>
                </Draggable>{' '}
              </div>
            )}
          >

              <Input
                  placeholder="ID/名称/老师"
                  suffix={<SearchOutlined style={{ color: '#666666' }} />}
                  onChange={(e) => {
                    queryClassRoom.current  = e.target.value
                  }}
                  onPressEnter={(e) => {
                    pageClassRoom.current =1; queryProjectClassRoomList( projectID.current, collegeId, false)
                  }}
                  style={{fontSize:16,padding:'12px 16px 12px 16px', borderRadius:8,margin:'0 24px 24px 10px', width:'calc(100% - 34px)'}}
                />

            {projectClassRoomList?.length != 0 ? (
              <div><Radio.Group
                buttonStyle="solid"
                onChange={(e: any) => {
                  selectedClassRoomId.current = e.target.value.id
                  setSelectedClassRoom(e.target.value)
                }}
              >
                {projectClassRoomList?.map((class_) => {
                  return (
                    <Radio.Button
                      key={class_.id}
                      value={class_}
                     
                    >
                      <div className={projectStyles.changeClassList}>
                        <div style={{height:25}}>
                        { selectedClassRoomId.current ==class_.id && <div className={projectStyles.changeClassCheckedIcon}><CheckCircleOutlined style={{color:'#4f46e5'}} /></div>}
      
                        </div>
                        <div style={{ fontSize: 18, fontWeight:600, marginBottom:4 }}>{class_.name}</div>
                        <div style={{fontSize:14, marginBottom:16, color:'rgb(107 114 128)'}}>班号： {class_.number}</div>

                        <Row wrap={false} gutter={16} align={'middle'} style={{marginBottom:16}}>
                                    <Col flex={'40px'} >
                                        <div style={{borderRadius:'50%',height:40, width:40}}>
                                            <img  src={ class_?.teacher_avatar?.startsWith("http") ? class_?.teacher_avatar : constants.BACKEND_API_URL + class_?.teacher_avatar}  style={{borderRadius:'50%', width:40,height:40}}/>   
                                        </div>     
                                    </Col>

                                    <Col flex={'auto'}>
                                        <div style={{marginLeft:12}}>
                                            <div style={{fontSize:16, fontWeight:600, color:'#1f2937'}}>{class_?.teacher_real_name?class_?.teacher_real_name:class_?.user_name}</div>
                                        </div>     
                                    </Col>
                        </Row>


                        <div>
                        <TeamOutlined  style={{marginRight:6}}/> 现有学员: {class_?.user_count} 人
                        </div>

                      </div>
                    </Radio.Button>
                  )
                })}
              </Radio.Group>

                <div style={{textAlign:'center'}}>
                  <ConfigProvider locale={zhCN}> 
                    <Pagination
                      //style={{ float: 'left' }}
                      defaultCurrent={1}
                      total={resultSumClassRoom}
                      pageSize={6}
                      current={pageClassRoom.current}
                      hideOnSinglePage={true}
                      onChange={onClassRoomPageChange}
                      showSizeChanger={false}
                      
                    />
                  </ConfigProvider>
                </div>

              
              </div>
            ) : (
              <div style={{ width: '100%', textAlign: 'center', color: '#ccc' }}>
                <img
                  src={classempty}
                  alt=""
                  width={200}
                  height={200}
                  style={{ margin: '40px auto' }}
                />
                <p>你所在机构老师还未创建班级哦，请联系老师创建后使用~</p>
              </div>
            )}
          </Modal>

          <Modal
            title={
              <div
                style={{ width: '100%', cursor: 'move', color: '#666' }}
                onMouseOver={() => {
                  if (disabled) {
                    setDisabled(false)
                  }
                }}
                onMouseOut={() => {
                  setDisabled(true)
                }}
                onFocus={() => {}}
                onBlur={() => {}}
              >
                加入班级:{selectedClassRoom?.name}
              </div>
            }
            width={420}
            closable={false}
            centered={true}
            open={inputClassPasswordModalVisible}
            bodyStyle={{
              padding: '20px 28px 4px',
              textAlign: 'left',
            }}
            className={projectStyles.chooseClassRoomDiv}
            footer={
              <div style={{ display: 'flex', justifyContent: 'center', gap: 12 }}>
                <Button
                  className={projectStyles.stepsBtn}
                  style={{ color: '#fff' }}
                  type="primary"
                  onClick={onConfirmInputClass}
                >
                  确认
                </Button>
                <Button
                  className={projectStyles.stepsBtn}
                  style={{
                    backgroundColor: '#f1f5f9',
                    border: 0,
                    color: '#475569',
                  }}
                  onClick={() => {
                    setJoinClassError('')
                    setInputClassPasswordModalVisible(false)
                  }}
                >
                  取消
                </Button>
              </div>
            }
            modalRender={(modal) => (
              <div>
                <Draggable
                  disabled={disabled}
                  bounds={bounds}
                  onStart={(event, uiData) => onStart(event, uiData)}
                >
                  <div ref={draggleRef}>{modal}</div>
                </Draggable>{' '}
              </div>
            )}
          >
            {joinClassError && (
              <div className={projectStyles.joinClassErrorMsg}>{joinClassError}</div>
            )}
            <div className={projectStyles.joinClassFormItem}>
              <label className={projectStyles.joinClassFormLabel}>班级密码</label>
              <Input
                onChange={(e) => {
                  inputClassRoomPassword.current = e.target.value
                }}
                placeholder="请输入班级密码"
              />
            </div>
            <div className={projectStyles.joinClassFormItem}>
              <label className={projectStyles.joinClassFormLabel}>真实姓名</label>
              <Input
                value={realName}
                onChange={(e) => {
                  setRealName(e.target.value)
                }}
                placeholder="请输入真实姓名"
              />
            </div>
            <div className={projectStyles.joinClassFormItem}>
              <label className={projectStyles.joinClassFormLabel}>学号</label>
              <Input
                value={realNumber}
                onChange={(e) => {
                  setRealNumber(e.target.value)
                }}
                placeholder="请输入学号"
              />
            </div>
          </Modal>

        </div>
      </div>
      <PageFooter />
    </Layout>
  )
}

export default ProjectList
